import React from 'react';
//internal and external components import
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { TableRow, Checkbox, Chip, TextField, ThemeProvider, createTheme, Tooltip, Typography,InputAdornment, TableHead  } from '@mui/material';
import { stableSort, getComparator } from '../../common/SortSupport';
import { EnhancedTableHead } from '../EnhancedTableHead';
import { Box } from '@mui/material';
import ActionDetailPopper from '../../containers/ActionDetailPopper';
import YenTextField from '../YenTextField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faCheck } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const theme = createTheme({
  components: {
    MuiStack: {
      styleOverrides: {
        root: {
          display: 'inline',
          width: '90px'
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          minWidth: '90px !important',
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: 12
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          width: 18,
          height: 18
        }
      }
    }
  },
})

const AccountingProfitLossSummaryTable = () => {
  const [t] = useTranslation();
  const data = useSelector((state:any) => state.dataCaptures.profitAndLossDetails);

  const incomeTotal = data.filter((d:any) => d.type == 'Income')?.reduce((acc:any, el:any) => {
    return acc + +el.currentYear;
  }, 0);
  const expenseTotal = data.filter((d:any) => d.type == 'Expense')?.reduce((acc:any, el:any) => {
    return acc + +el.currentYear;
  }, 0);

  const labourCost = data.filter((d:any) => d.type == 'Expense')
    ?.filter((el:any) => el.name === 'Labour Cost')
    .reduce((acc:any, el:any) => acc + +el.currentYear, 0);
  const equipmentCost = data.filter((d:any) => d.type == 'Expense')
    ?.filter((el:any) => el.name === 'Equipment/Fixtures')
    .reduce((acc:any, el:any) => acc + +el.currentYear, 0);
  const facilitiesCost = data.filter((d:any) => d.type == 'Expense')
    ?.filter((el:any) => el.name === 'Facilities')
    .reduce((acc:any, el:any) => acc + +el.currentYear, 0);
  const travelCost = data.filter((d:any) => d.type == 'Expense')
    ?.filter((el:any) => el.name === 'Travel')
    .reduce((acc:any, el:any) => acc + +el.currentYear, 0);

  //table contents
    return(
        <React.Fragment>
          <ThemeProvider theme={theme}>
          <Box sx={{ mt: '10px', display: 'grid', gridTemplateColumns: 'calc(100%/4.1) calc(100%/4.1) calc(100%/4.1) calc(100%/4.1)', gridColumnGap: '10px' }}>
                    {/* total table */}
                    <TableContainer>
                      <Table stickyHeader size="small" aria-label="a dense table">
                        <TableHead>
                          <TableRow>
                            <TableCell className='uppercase fs12' sx={{ backgroundColor: '#FAFAFA' }}>
                              {t('TOTAL')}
                            </TableCell>
                            <TableCell className='uppercase fs12' sx={{ backgroundColor: '#FAFAFA' }}>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell className='fs12'>
                              {t('DC_3_INCOME')}
                            </TableCell>
                            <TableCell className='fs12 maxContentWidth'>
                              {'¥ ' + incomeTotal?.toLocaleString()}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className='fs12'>
                              {t('DC_3_EXPENCE')}
                            </TableCell>
                            <TableCell className='fs12 maxContentWidth'>
                              {'¥ ' + expenseTotal?.toLocaleString()}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className='fs12'>
                              {t('DC_3_NET')}
                            </TableCell>
                            <TableCell className='fs12 maxContentWidth'>
                              {'¥ ' + (incomeTotal - expenseTotal).toLocaleString()}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                    {/* total expense table */}
                    <TableContainer>
                      <Table stickyHeader size="small" aria-label="a dense table">
                        <TableHead>
                          <TableRow>
                            <TableCell className='uppercase fs12' sx={{ backgroundColor: '#FAFAFA' }}>
                              {t('EXPENSE_TOTAL')}
                            </TableCell>
                            <TableCell className='uppercase fs12' sx={{ backgroundColor: '#FAFAFA' }}>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell className='fs12'>
                              {t('DC_3_LABOUR_COST')}
                            </TableCell>
                            <TableCell className='fs12 maxContentWidth'>
                              {'¥ ' + labourCost?.toLocaleString()}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className='fs12'>
                              {t('DC_3_EQUIPMENT_FIXTURES')}
                            </TableCell>
                            <TableCell className='fs12 maxContentWidth'>
                              {'¥ ' + equipmentCost?.toLocaleString()}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className='fs12'>
                              {t('DC_3_FACILITIES')}
                            </TableCell>
                            <TableCell className='fs12 maxContentWidth'>
                              {'¥ ' + facilitiesCost?.toLocaleString()}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className='fs12'>
                              {t('DC_3_TRAVEL')}
                            </TableCell>
                            <TableCell className='fs12 maxContentWidth'>
                              {'¥ ' + travelCost?.toLocaleString()}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                    {/* figure table */}
                    <TableContainer>
                      <Table stickyHeader size="small" aria-label="a dense table">
                        <TableHead>
                          <TableRow>
                            <TableCell className='uppercase fs12' sx={{ backgroundColor: '#FAFAFA' }}>
                              {`${data[0]?.year - 1} ${t('DC_3_FIGURE')}`}
                            </TableCell>
                            <TableCell className='uppercase fs12' sx={{ backgroundColor: '#FAFAFA' }}>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell className='fs12'>
                              {t('DC_3_CLUB_TOTAL_INCOME')}
                            </TableCell>
                            <TableCell className='fs12 maxContentWidth'>
                              {'¥ ' +
                                data?.filter((d:any) => d.type == 'Total')
                                  .find((el:any) => el.type === 'Total' && el.name === 'Income')
                                  ?.currentYear?.toLocaleString() || 0}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className='fs12'>
                              {t('DC_3_CLUB_TOTAL_EXPENSE')}
                            </TableCell>
                            <TableCell className='fs12 maxContentWidth'>
                              {'¥ ' +
                                 data?.filter((d:any) => d.type == 'Total')
                                  .find((el:any) => el.type === 'Total' && el.name === 'Expense')
                                  ?.currentYear?.toLocaleString() || 0}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                    {/* budget table */}
                    <TableContainer>
                      <Table stickyHeader size="small" aria-label="a dense table">
                        <TableHead>
                          <TableRow>
                            <TableCell className='uppercase fs12' sx={{ backgroundColor: '#FAFAFA' }}>
                              {`${data[0]?.year} ${t('DC_3_BUDGET')}`}
                            </TableCell>
                            <TableCell className='uppercase fs12' sx={{ backgroundColor: '#FAFAFA' }}>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell className='fs12'>
                              {t('DC_3_CLUB_TOTAL_INCOME')}
                            </TableCell>
                            <TableCell className='fs12 maxContentWidth'>
                              {'¥ ' +
                                data?.filter((d:any) => d.type == 'Total')
                                  .find((el:any) => el.type === 'Total' && el.name === 'Income')
                                  ?.nextYear?.toLocaleString() || 0}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className='fs12'>
                              {t('DC_3_CLUB_TOTAL_EXPENSE')}
                            </TableCell>
                            <TableCell className='fs12 maxContentWidth'>
                              {'¥ ' +
                                 data?.filter((d:any) => d.type == 'Total')
                                  .find((el:any) => el.type === 'Total' && el.name === 'Expense')
                                  ?.nextYear?.toLocaleString() || 0}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                </Box>
          </ThemeProvider>
        </React.Fragment>
    )
}

export default AccountingProfitLossSummaryTable;